import { ethers } from "ethers";
import { formatResult } from "helpers/utils";
import { Token } from "types";

export async function getERC20balance(account: string, token: Token, provider: any) {
  const contract = new ethers.Contract(token.address, token.abi, provider);
  return formatResult(await contract.balanceOf(account), token.decimals);
}
